import React from 'react';
import AdminManualInvoices from './AdminManualInvoices';

const AdminManualQuotes = (props) => (
  <AdminManualInvoices {...props} mode="quote" />
);

export default AdminManualQuotes;
